import {PageLayout} from "base/layout";
import {LogoLink, PaperContainer, TextLink} from "base/component/presentational";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

const logos = [
    <LogoLink
        key={"ismar"}
        href="https://www.ismar.cnr.it/"
        title="ISMAR website"
        src="/images/logos/logo_ismar.png"
        alt="ISMAR logo"
        logoHeight={60}
    />,
    <LogoLink
        key={"shom"}
        href="https://www.shom.fr/"
        title="SHOM website"
        src="/images/logos/logo_shom.jpg"
        alt="SHOM logo"
        logoHeight={60}
    />,
    <LogoLink
        key={"cedex"}
        href="https://cedex.es/"
        title="CEDEX website"
        src="/images/logos/logo_cedex.jpg"
        alt="CEDEX logo"
        logoHeight={60}
    />,
    <LogoLink
        key={"ulpgc"}
        href="https://www.ulpgc.es/"
        title="ULPGC website"
        src="/images/logos/logo_ulpgc.png"
        alt="ULPGC logo"
        logoHeight={60}
    />,
    <LogoLink
        key={"helcom"}
        href="https://helcom.fi/"
        title="HELCOM website"
        src="/images/logos/logo_helcom.png"
        alt="HELCOM logo"
        logoHeight={60}
    />,
    <LogoLink
        key={"cetmar"}
        href="https://cetmar.org/"
        title="CETMAR website"
        src="/images/logos/logo_cetmar.png"
        alt="CETMAR logo"
        logoHeight={60}
    />,
    <LogoLink
        key={"corila"}
        href="https://www.corila.it/"
        title="CORILA website"
        src="/images/logos/logo_corila.png"
        alt="CORILA logo"
        logoHeight={60}
    />,
];

export const MainAboutPage = () => {
    return (
        <PageLayout subPage>
            <Stack spacing={1}>
                <PaperContainer>
                    <Typography variant="h4" marginTop={1} marginBottom={2}>
                        About ReMAP
                    </Typography>

                    <Stack spacing={2}>
                        <Typography>
                            The European project{" "}
                            <span style={{fontStyle: "italic"}}>
                                Reviewing and Evaluating the Monitoring and Assessment
                                of Maritime Spatial Planning
                            </span>{" "}
                            (
                            <TextLink
                                text={"ReMAP"}
                                to={
                                    "https://maritime-spatial-planning.ec.europa.eu/projects/reviewing-and-evaluating-monitoring-and-assessment-maritime-spatial-planning"
                                }
                            />
                            ) aims to enhance the capacity to monitor and assess
                            Maritime Spatial Planning (MSP). It delivers a suite of 10+1
                            independent, reusable, and interoperable web-based tools,
                            grounded in an innovative technical framework. These tools
                            build on existing EU data infrastructures and initiatives to
                            support Member States in evaluating the performance of their
                            MSPs, improving data consistency, cross-border cooperation,
                            and integration with related policies such as the Marine
                            Strategy Framework Directive.
                        </Typography>
                        <Typography>
                            The ReMAP framework combines modular and integrated
                            analytical approaches covering environmental, economic,
                            social, governance, and safety dimensions. Usability is a
                            key asset, and the tools are tested in a variety of
                            contexts, including local (Galicia, Spain) and cross-border
                            case studies in the Western Mediterranean and Baltic Sea.
                            Co-developed with stakeholder input, ReMAP provides
                            practical and sustainable solutions to help Member States
                            effectively implement, monitor, and revise their maritime
                            spatial plans.
                        </Typography>
                    </Stack>
                </PaperContainer>

                <Stack>
                    <Box
                        sx={{
                            backgroundImage: 'url("/images/footer_bg.png")',
                            backgroundSize: "cover",
                            backgroundPosition: "top",
                            backgroundRepeat: "no-repeat",
                            width: "100%",
                            height: 275,
                        }}
                    />
                    <Grid container>
                        {logos.map((logo, index) => (
                            <Grid
                                item
                                container
                                xs
                                key={index}
                                justifyContent="center"
                                alignContent="center"
                                bgcolor={"white"}
                            >
                                {logo}
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container bgcolor="white" pl={3} pt={3} pb={1}>
                        <Grid item>
                            <LogoLink
                                key={"ue"}
                                title="Co-funded by the UE"
                                src="/images/logos/logo_co-funded-ue.png"
                                alt="Co-funded by the UE logo"
                                logoHeight={60}
                            />
                        </Grid>
                        <Grid item container alignContent="center">
                            <Typography variant="body2" color="text.secondary">
                                This project has received funding from the European
                                Maritime, Fisheries, and Aquaculture Fund (EMFAF) under
                                Grant Agreement No 101081304.
                            </Typography>
                        </Grid>
                    </Grid>
                </Stack>
            </Stack>
        </PageLayout>
    );
};
